<template>
    <img :class="[$style['mds-profile-image']]" :src="src" :alt="alt" :data-mds-version="version" />
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsProfileImage',
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            alt: {
                type: String,
                required: true,
                docs: {
                    validation: '**Required**',
                    description: 'Sets the `alt` text for the profile image.',
                },
            },
            src: {
                type: String,
                required: true,
                docs: {
                    validation: '**Required**',
                    description: 'Sets the `src` path for the profile image.',
                },
            },
        },
    };
</script>

<style lang="scss" module>
    @import './profile-image.scss';
</style>
